import { NavLink } from "react-router-dom";


const FlexibleVideoDisplay = ({ data, isDonor, isCreator, translation }) => {
  // Get all available videos from the post_videos object
  const getAvailableVideos = () => {
    if (!data?.post_videos?.videos) return [];
    
    const videos = data.post_videos.videos;
    const availableVideos = [];
    
    // List of possible video keys - add more as needed
    const videoKeys = [
      "place_video",
      "seeker_video",
      "patient_video",
      "orphan_video",
      "committee_member_video",
    ];
    
    videoKeys.forEach(key => {
      if (videos[key]) {
        availableVideos.push({
          key,
          url: videos[key],
          // Optional: Add display names for each video type
          displayName: getVideoDisplayName(key)
        });
      }
    });
    
    // Limit to maximum 2 videos
    return availableVideos.slice(0, 2);
  };
  
  // Optional: Function to get user-friendly names for video types
  const getVideoDisplayName = (videoKey) => {
    const displayNames = {
      'seeker_video': 'Seeker Video',
      'place_video': 'Location Video',
      'patient_video': 'Patient Video',
      'orphan_video': "Orphan Video",
      "committee_member_video": "Committee Member Video"
    };
    return displayNames[videoKey] || 'Video';
  };
  
  const availableVideos = getAvailableVideos();
  
  // Determine grid layout based on number of videos
  const getGridClass = () => {
    if (availableVideos.length === 0) return 'grid grid-cols-1';
    if (availableVideos.length === 1) return 'grid grid-cols-1';
    return 'grid grid-cols-1 md:grid-cols-2 gap-4';
  };
  
  // Render placeholder when no videos or user doesn't have access
  const renderPlaceholder = (videoKey = '') => (
    <div className='flex justify-center items-center bg-gray-700 text-white opacity-80 m-10 min-h-[200px]'>
      <span>
        {isCreator ? `${translation.video_in_process}` : `${translation.only_donor}`} <NavLink to="/donor-community" className="text-blue-600 hover:underline dark:text-blue-400">{translation.join_now}</NavLink>
      </span>
    </div>
  );
  
  // Render individual video
  const renderVideo = (video) => (
    <div key={video.key} className='border border-black'>
      {isDonor ? (
        <div>
          {/* Optional: Show video title/type */}
          {/* <div className='bg-gray-100 p-2 text-sm font-medium'>
            {video.displayName}
          </div> */}
          <video className='detailVideo w-full' controls controlsList="nodownload">
            <source src={`${process.env.REACT_APP_CDN_URL}/${video.url}`} type="video/mp4" />
            {translation.video_not_support} 
          </video>
        </div>
      ) : (
        renderPlaceholder(video.key)
      )}
    </div>
  );
  
  return (
    <div className={getGridClass()}>
      {availableVideos.length > 0 ? (
        availableVideos.map(video => renderVideo(video))
      ) : (
        // Show placeholder when no videos available
        <div className='border border-black'>
          {renderPlaceholder()}
        </div>
      )}
    </div>
  );
};

export default FlexibleVideoDisplay;